import { Divider, styled } from "@mui/material"
import { useState, type FC } from "react"
import { MainContent } from "../components/MainContent"
import { AdditionalDataSources } from "../components/Wastewater/DataSources/AdditionalDataSources"
import { WastewaterAnomalies } from "../components/Wastewater/WastewaterAnomalies"

import { BetaTag } from "../components/BetaTag"
import { WastewaterProvider } from "../components/Wastewater/WastewaterContext"
import { WastewaterHeatmap } from "../components/Wastewater/WastewaterHeatmap"
import { extraColors } from "../utils/theme"

const Header = styled("div")(() => ({
  display: "flex",
  gap: 17,
  alignItems: "stretch",
  padding: "0 24px",
  marginBottom: 32,
}))

const DEFAULT_SITE_ID = "201 HI JBPHH"
const DATA_LIMIT = 10000

export const WastewaterOahu: FC = () => {
  const [heatmapHeight, setHeatmapHeight] = useState<number | null>(null)

  return (
    <MainContent
      headerProps={{
        title: (
          <>
            Oahu <BetaTag />
          </>
        ),
        documentTitle: "Oahu",
      }}
      disableHorizontalGutters
    >
      <Header style={heatmapHeight ? { height: heatmapHeight } : undefined}>
        <WastewaterProvider>
          <WastewaterHeatmap
            phcSiteId={DEFAULT_SITE_ID}
            limit={DATA_LIMIT}
            onHeightChange={setHeatmapHeight}
          />
          <Divider
            orientation="vertical"
            flexItem
            color={extraColors.disabled}
          />
          <WastewaterAnomalies
            phcSiteId={DEFAULT_SITE_ID}
            limit={DATA_LIMIT}
            maxHeight={heatmapHeight ?? undefined}
          />
        </WastewaterProvider>
      </Header>
      <AdditionalDataSources />
    </MainContent>
  )
}
